import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../contexts/TranslationContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireSubscription?: boolean;
  requirePlan?: number;
  requireFeature?: string;
  requireAdmin?: boolean;
  requireExpert?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireSubscription = false,
  requirePlan,
  requireFeature,
  requireAdmin = false,
  requireExpert = false,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isAuthenticated, isAdmin, isExpert, loading, hasSubscription, hasFeature } = useAuth();

  if (loading) {
    return (
      <div className="protected-route__loading">
        <div className="protected-route__spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (requireExpert && !isExpert) {
    return <Navigate to="/" replace />;
  }

  if (requireSubscription && !hasSubscription()) {
    return <Navigate to="/" replace />;
  }

  if (requirePlan && !hasSubscription(requirePlan)) {
    return <Navigate to="/" replace />;
  }

  if (requireFeature && !hasFeature(requireFeature)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
